import { useState } from "react";
import { siteMeta } from "@/mocks/home";

interface SubscribeSectionProps {
  notify: (message: string) => void;
}

export default function SubscribeSection({ notify }: SubscribeSectionProps) {
  const [email, setEmail] = useState("");

  const handleSubscribe = () => {
    const value = email.trim();
    if (!value || !value.includes("@")) {
      notify("请填写正确的邮箱地址");
      return;
    }
    setEmail("");
    notify("订阅成功，地址有更新会第一时间提醒你");
  };

  return (
    <section id="subscribe" className="bg-background-50 py-14 md:py-20 px-4 md:px-10">
      <div className="relative overflow-hidden rounded-2xl bg-background-100 border border-background-200 px-5 py-9 md:px-12 md:py-12">
        <div className="absolute -right-16 -top-16 w-56 h-56 rounded-full bg-accent-100/60 blur-2xl pointer-events-none" />
        <div className="relative grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-6">
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600 uppercase">
              <i className="ri-notification-3-line" />
              更新提醒
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-balance">
              留下邮箱，换地址时不用自己找
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              有新的可用入口、线路调整或维护公告时，我们会同步提醒，让你第一时间拿到{siteMeta.name}
              的最新地址。
            </p>
          </div>

          <div className="lg:col-span-6">
            <div className="flex flex-col sm:flex-row gap-2.5">
              <div className="flex items-center gap-2 flex-1 h-12 px-3.5 rounded-md bg-background-50 border border-background-200 focus-within:border-primary-300 transition-colors">
                <i className="ri-mail-line text-foreground-400" />
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="you@example.com"
                  className="flex-1 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 outline-none"
                />
              </div>
              <button
                type="button"
                onClick={handleSubscribe}
                className="inline-flex items-center justify-center gap-1.5 h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-send-plane-line" />
                订阅更新
              </button>
            </div>
            <p className="mt-3 text-xs text-foreground-500">
              只发送地址与维护通知，不会用于其他用途，可随时取消。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}